import { render, staticRenderFns } from "./DialogAssignPlataforma.vue?vue&type=template&id=bee5aed0"
import script from "./DialogAssignPlataforma.vue?vue&type=script&lang=js"
export * from "./DialogAssignPlataforma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports